import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  COOKIE,
  ENUM_SERVER_CODE,
  Environment,
  AuthResponse,
  IClientNg,
  IsError,
  IsErrorValues,
  LoginCheckUserNameAzbModel,
  ModelStr,
  LoginViewModel,
} from '../../models/-index';
import { Router } from '@angular/router';
import { JwtHelperService } from './jwt-helper.service';
import { SecurityService } from './security.service';

// import { ENVIRONMENT_TOKEN } from 'projects/app-lib/src//lib/environment-token';

@Injectable()
export class AutenticazioneService {
  private env: Environment;

  constructor(
    private _security: SecurityService,
    private http: HttpClient,
    private _CookieService: CookieService,
    @Inject('ENV') environment: Environment,
    private _jwthelper: JwtHelperService
  ) {
    this.env = environment;
  }

  // verifica username passo 1
  public CheckIfExist_ByUserName(username): Observable<LoginCheckUserNameAzbModel> {
    username = btoa(username);
    return this.http.get<LoginCheckUserNameAzbModel>(
      `${this.env.apiUrl}/api/Account/CheckUserIfExist_ByEncUsername?estr=` + username
    );
  }
  // recupera username
  public GetUserName_SendEmail(email): Observable<IsError> {
    email = btoa(email);
    return this.http.get<IsError>(`${this.env.apiUrl}/api/Account/GetUserName_SendEmail?estr=` + email);
  }

  // cambio password
  SetCambioPassword_SendMailSecurityCode(idutente: string): Observable<IsErrorValues> {
    const model: ModelStr = { Value: btoa(idutente) };
    const u = `${this.env.apiUrl}/api/Account/SetCambioPassword_SendMailSecurityCode`;
    return this.http.post<any>(`${u}`, model);
  }

  public LoginLogin(input: LoginViewModel): Observable<AuthResponse> {
    //  .log('loginpath ===>' + `${this.env.apiUrl}/api/Account/Login`);
    // .log('->' + JSON.stringify(data, null, 4));
    /*
    const obs_ng$ = this.http.get<IClientNg>(`${this.env.apiUrl}/api/Account/Get_ClientNg`).pipe(
      map((r: IClientNg) => {
        if (r) {
          const str = JSON.stringify(r);
          const en64 = btoa(str);
          this._CookieService.set(COOKIE.SYS_SETTINGS, en64, 365, '/', window.location.hostname, false, 'Lax');
        } else {
          throw new Error('Cannot api/Account/Get_ClientNg ');
        }
      })
    );

    const obs_login$ = this.http.post<AuthResponse>(`${this.env.apiUrl}/api/Account/Login`, data).pipe(
      map((data: AuthResponse) => {
        // login successful if there's a jwt token in the response
        if (data && data.IsErr == false) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          const tok = data.Message;

          this._CookieService.set(COOKIE.SYS_JWT, tok, 365, '/', window.location.hostname, false, 'Lax');

          //  localStorage.setItem('currentUser', JSON.stringify(tok));
        } else {
          if (data.RedirectCode == ENUM_SERVER_CODE.LOGIN_PASSCHANGE) {
            this._CookieService.set(COOKIE.SYS_JWT, data.RedirectId, 15, '/', window.location.hostname, false, 'Lax');
          }
        }
        return data;
      })
    );
*/
    return this.http.post<AuthResponse>(`${this.env.apiUrl}/api/Account/Login`, input).pipe(
      switchMap((data: AuthResponse) => {
        // login successful if there's a jwt token in the response
        //onsole.log(`${this.env.apiUrl}/api/Account/Login   \n` + JSON.stringify(data, null, 4));

        if (data && data.IsErr == false) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          const tok = data.Message;

          this._CookieService.set(COOKIE.SYS_JWT, tok, 365, '/', window.location.hostname, false, 'Lax');

          if (data.IsAuthorized == true) {
            const jwtuser = this.format_schemas(JSON.stringify(this._jwthelper.decodeToken(tok)));

            return this.http.get<IClientNg>(`${this.env.apiUrl}/api/Account/Get_ClientNg?az=${jwtuser.azbase}`).pipe(
              map((r: IClientNg) => {
                if (r) {
                  const str = JSON.stringify(r);
                  const en64 = btoa(str);
                  this._CookieService.set(COOKIE.SYS_SETTINGS, en64, 365, '/', window.location.hostname, false, 'Lax');
                  return data;
                } else {
                  throw new Error('Cannot api/Account/Get_ClientNg ');
                  //  return false
                }
              })
            );
          }
        } else {
          if (data.RedirectCode == ENUM_SERVER_CODE.LOGIN_PASSCHANGE) {
            this._CookieService.set(COOKIE.SYS_JWT, data.RedirectId, 15, '/', window.location.hostname, false, 'Lax');
            //  return false;
          }
        }
        return of(data);
      })
    );

    /*
    return this.http.post<AuthResponse>(`${this.env.apiUrl}/api/Account/Login`, data).pipe(
      switchMap((data: AuthResponse) => {
        // login successful if there's a jwt token in the response
        if (data && data.IsErr == false) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          const tok = data.Message;

          this._CookieService.set(COOKIE.SYS_JWT, tok, 365, '/', window.location.hostname, false, 'Lax');

          return this.http.get<IClientNg>(`${this.env.apiUrl}/api/Account/Get_ClientNg`).pipe(
            map((r: IClientNg) => {
              if (r) {
                const str = JSON.stringify(r);
                const en64 = btoa(str);
                this._CookieService.set(COOKIE.SYS_SETTINGS, en64, 365, '/', window.location.hostname, false, 'Lax');
             //  return  data;
              } else {
                throw new Error('Cannot api/Account/Get_ClientNg ');
                //  return false
              }
            })
          );

          //  localStorage.setItem('currentUser', JSON.stringify(tok));
        } else {
          if (data.RedirectCode == ENUM_SERVER_CODE.LOGIN_PASSCHANGE) {
            this._CookieService.set(COOKIE.SYS_JWT, data.RedirectId, 15, '/', window.location.hostname, false, 'Lax');
          }
        }
        return data;
      })
    );*/
  }
  Login_bak(data: LoginViewModel): Observable<AuthResponse> {
    //  .log('loginpath ===>' + `${this.env.apiUrl}/api/Account/Login`);
    // .log('->' + JSON.stringify(data, null, 4));
    return this.http.post<AuthResponse>(`${this.env.apiUrl}/api/Account/Login`, data).pipe(
      map((data: AuthResponse) => {
        // login successful if there's a jwt token in the response
        if (data && data.IsErr == false) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          const tok = data.Message;

          this._CookieService.set(COOKIE.SYS_JWT, tok, 365, '/', window.location.hostname, false, 'Lax');
          //  localStorage.setItem('currentUser', JSON.stringify(tok));
        } else {
          if (data.RedirectCode == ENUM_SERVER_CODE.LOGIN_PASSCHANGE) {
            this._CookieService.set(COOKIE.SYS_JWT, data.RedirectId, 15, '/', window.location.hostname, false, 'Lax');
          }
        }
        return data;
      })
    );
  }
  Logout() {
    // remove user from local storage to log user out
    // localStorage.removeItem('currentUser');

    console.warn('NG.ATH.OUT.WRN.00 --- Logout() in AutenticazioneService delete all system cookies');

    this._CookieService.delete(COOKIE.SYS_JWT, window.location.hostname);
    this._CookieService.delete(COOKIE.SYS_SETTINGS, window.location.hostname);
  }

  private getClientNgFromServer(az: number): Observable<boolean> {
    return this.http.get<IClientNg>(`${this.env.apiUrl}/api/Account/Get_ClientNg?az=${az}`).pipe(
      map((r: IClientNg) => {
        if (r) {
          const str = JSON.stringify(r);
          const en64 = btoa(str);
          this._CookieService.set(COOKIE.SYS_SETTINGS, en64, 365, '/', window.location.hostname, false, 'Lax');
          return true;
        } else {
          throw new Error('Cannot api/Account/Get_ClientNg ');
          //  return false
        }
      })
    );
  }
  private format_schemas(json_string) {
    return JSON.parse(json_string, function (key, value) {
      if (!key.startsWith('http://schemas')) {
        return value;
      }
    });
  }
  public PassChange(data: LoginViewModel, token: string) {
    var myHeaders = new HttpHeaders();
    myHeaders.append('Authorization', 'Bearer ' + token);
    //  myHeaders.append('InterceptorSkipHeader', '');

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        InterceptorSkipHeader: '',
      }),
    };
    return this.http.post(`${this.env.apiUrl}/api/Account/PChange`, data, httpOptions);
    //   return this.http.post(`${this.config.apiUrl}/api/Account/PChange`, data, { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + token }) });
  }

  // sulla barra dei menu cambia la divisione
  OnChange_Divisione(div: number): Observable<boolean> {
    return this.http.post<IsErrorValues>(`${this.env.apiUrl}/api/Divisioni/OnChange_Divisione?id=${div}`, null).pipe(
      map((data: IsErrorValues) => {
        if (data && data.IsErr == false) {
          // tokrn in r.StringValue
          const tok = data.StringValue;
          this._security.Refresh_JwtToken(tok);
          if (data.Continue != true) {
            //  this._CookieService.delete(COOKIE.SYS_SETTINGS, window.location.hostname);
            // Number(r.Code) utilizzato per ritornare la nuova azienda
            //  return this.getClientNgFromServer(Number(data.Code));
          } else {
            return true;
          }
        } else {
          throw new Error('NG.AUT.DIV.ER.01 ' + data.Message);
        }
      })
    );
  }

  // sulla barra dei menu cambia la divisione
  OnChange_Divisione_bak(div: number): Observable<boolean> {
    return this.http.post<IsErrorValues>(`${this.env.apiUrl}/api/Divisioni/OnChange_Divisione?id=${div}`, null).pipe(
      switchMap((data: IsErrorValues) => {
        if (data && data.IsErr == false) {
          // tokrn in r.StringValue
          const tok = data.StringValue;
          this._security.Refresh_JwtToken(tok);
          if (data.Continue != true) {
            //  this._CookieService.delete(COOKIE.SYS_SETTINGS, window.location.hostname);
            // Number(r.Code) utilizzato per ritornare la nuova azienda
            //  return this.getClientNgFromServer(Number(data.Code));
          } else {
            return of(true);
          }
        } else {
          throw new Error('NG.AUT.DIV.ER.01 ' + data.Message);
        }
      })
    );
  }

  //  cambia la cultura
  OnChange_Culture(lingua2letters: string) {
    const lng: ModelStr = { Value: lingua2letters };
    return this.http.post<IsErrorValues>(`${this.env.apiUrl}/api/Utenti/OnChange_Culture`, lng).pipe(
      switchMap(async (data: IsErrorValues) => {
        if (data && data.IsErr == false) {
          const tok = data.StringValue;
          //onsole.log('==OnChange_Culture autenticazione ritorno =>' + data.StringValue);

          this._security.Refresh_JwtToken(tok);
          // se  Continue ricrea anche
          /*     if (data.Continue != true) {
              // Number(r.Code) utilizzato per ritornare la nuova azienda
              return this.LoginStore_NgSettings(Number(data.Code)).subscribe();
            } else {
              return null;
            }*/
        } else {
          throw new Error('NG.AUT.ER.00 ' + data.Message);
        }
      })
    );
  }

  //
  public decodeToken(token: string = '') {
    // .log('token???? ' + token);
    if (token === null || token === '') {
      return { upn: '' };
    }
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('JWT must have 3 parts');
    }
    const decoded = this.urlBase64Decode(parts[1]);
    if (!decoded) {
      throw new Error('Cannot decode the token');
    }
    return JSON.parse(decoded);
  }
  private urlBase64Decode(str: string) {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0:
        break;
      case 2:
        output += '==';
        break;
      case 3:
        output += '=';
        break;
      default:
        // tslint:disable-next-line:no-string-throw
        throw 'Illegal base64url string!';
    }
    return decodeURIComponent((<any>window).escape(window.atob(output)));
  }
}
